<svg
  [attr.aria-label]="label"
  [ngClass]="[
    'base-icon',
    iconClass,
    iconColor,
    iconSize,
    disabled ? 'disabled' : ''
  ]">
  <use [attr.xlink:href]="srcSelected" [attr.href]="srcSelected"></use>
</svg>
